import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const Vehicles = () => {
    return (
        <div id="vehicles">
            <ContentBlock className="vehicleSummary">
                <ContentHeading title="Vehicles" />
                <ContentBody>
                    <div className="heading5">Electric vehicle, or EV, is an overarching term used to describe three types of vehicles: battery electric vehicles (BEVs), plug-in hybrid electric vehicles (PHEVs), and hybrid electric vehicles (HEVs), the latter of which technically isn't "electric" since they must have fossil fuels to operate.</div>
                    <Row className="electrificationBasicsContent">
                        {/* Battery Electric Vehicles Table */}
                        <Row className="vehicleTable batteryTwoBorder">
                            <Col lg={2} md={12} sm={12} className="vehicleDetailsTableLeft batteryTwoBackground" >
                                Battery Electric
                                Vehicles
                            </Col>
                            <Col lg={4} md={6} sm={12} className="vehicleDetailsTableCenter" >
                                <div className="evBasicsBatteryElectricVehicle backgroundImages"></div>
                                <Row className="header">Run on 100% electricity.</Row>
                                <Row className="content">The electric-charged battery powers the electric motor, which propels the car forward.</Row>
                            </Col>
                            <Col lg={6} md={6}  sm={12} className="vehicleDetailsTableRight" >
                                <Row>
                                    <div className="header">Power source</div>
                                    <div className="content">Electric battery</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Charging ability</div>
                                    <div className="content">Fast charging and Level 2 charging</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Range</div>
                                    <div className="content">150-500 miles (electric)<sup className={'super-footnote'}>1</sup></div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Average annual tailpipe emissions</div>
                                    <div className="content">Zero<sup className={'super-footnote'}>2</sup></div>
                                </Row>
                            </Col>
                        </Row>

                        {/* Plug-In Electric Hybrid Vehicles */}
                        <Row className="vehicleTable accentOneBorder">
                            <Col lg={2} md={12} sm={12} className="vehicleDetailsTableLeft accentOneBackground" >
                                Plug-In Electric
                                Hybrid Vehicles
                            </Col>
                            <Col lg={4} md={6} sm={12} className="vehicleDetailsTableCenter" >
                                <div className="evBasicsPlugInHybridVehicle backgroundImages"></div>
                                <Row className="header">Combine a battery-powered electric motor with an internal combustion engine.</Row>
                                <Row className="content">When the battery runs out of charge, the internal combustion engine serves as a backup.</Row>
                            </Col>
                            <Col lg={6} md={6} sm={12} className="vehicleDetailsTableRight" >
                                <Row>
                                    <div className="header">Power source</div>
                                    <div className="content">Battery-powered electric motor and internal combustion engine <br />backup</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Charging ability</div>
                                    <div className="content">Level 2 charging</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Range</div>
                                    <div className="content">15-50 miles (electric) and 300-640 miles (electric + gas)<sup className={'super-footnote'}>1</sup></div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Average annual tailpipe emissions</div>
                                    <div className="content">2,939 pounds of CO2<sup className={'super-footnote'}>2</sup></div>
                                </Row>
                            </Col>
                        </Row>

                        {/* Hybrid Vehicles */}
                        <Row className="vehicleTable surface9Border">
                            <Col lg={2} md={12} sm={12} className="vehicleDetailsTableLeft surface9Background" >
                                Hybrid Vehicles
                            </Col>
                            <Col lg={4} md={6} sm={12} className="vehicleDetailsTableCenter" >
                                <div className="evBasicsHybridVehicle backgroundImages"></div>
                                <Row className="header">Combine an internal combustion engine and an electric propulsion system.</Row>
                                <Row className="content">More efficient than standard vehicles but still fueled by gasoline or diesel. Not capable of outside electric charging.</Row>
                            </Col>
                            <Col lg={6} md={6} sm={12} className="vehicleDetailsTableRight" >
                                <Row>
                                    <div className="header">Power source</div>
                                    <div className="content">Internal combustion engine and electric propulsion system</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Charging ability</div>
                                    <div className="content">Does not require charging</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Range</div>
                                    <div className="content">500 miles (one tank of gas)</div>
                                </Row>
                                <Row className="borderTop">
                                    <div className="header">Average annual tailpipe emissions</div>
                                    <div className="content">6,898 pounds of CO2<sup className={'super-footnote'}>2</sup></div>
                                </Row>
                            </Col>
                        </Row>

                        <div className="disclaimer">
                            <p><sup className={'super-footnote'}>1</sup>Based on light-duty vehicles. Range and fuel economy of medium- and heavy-duty BEVs and PHEVs vary with vehicle size, application, and duty cycle.</p>
                            <p><sup className={'super-footnote'}>2</sup>Source: <a href="https://afdc.energy.gov/vehicles/electric_emissions.html" target="_blank" rel="noreferrer" >Alternative Fuels Data Center: Emissions from Electric Vehicles (energy.gov)</a></p>
                        </div>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
